import { Component, OnInit } from "@angular/core";
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";
import { ApplicationService } from "../application/application.service";
import { DashboardService } from "./dashboard.service";
import * as moment from "moment";
import { _ } from "underscore";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import { DatePipe } from '@angular/common'
import { isArray } from "ngx-bootstrap/chronos";
import { ToastrService } from 'ngx-toastr';
import { FindValueOperator } from "rxjs/internal/operators/find";
declare var alasql: any;
declare var $: any;
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [DatePipe],
})
export class DashboardComponent implements OnInit {
  appName: any;
  yeartoActive: any;
  wabaChartGraphsVar = [];
  test: any = [];
  chart: AmChart;
  chartReceived: AmChart;
  templateChart: AmChart;
  templateDeliveredChart: AmChart;

    wabaChartOptions = {
      type: "serial",
      theme: "none",
      mouseWheelZoomEnabled: true,
      dataProvider: [],
      legend: {
        horizontalGap: 10,
        maxColumns: 2,
        position: "top",
        useGraphSettings: true,
        markerSize:6,
      },
      valueAxes: [
        {
          stackType: "regular",
          axisAlpha: 0.3,
          gridAlpha: 0,
          calculateTotals : true
        },
      ],
      graphs: this.wabaChartGraphsVar,
      categoryField: "date",
      categoryAxis: {
        gridPosition: "start",
        gridAlpha: 0,
        tickPosition: "start",
        tickLength: 20,
        labelPosition: "middle",
        labelRotation: 45,
      },
      export: {
        enabled: true,
      }
 }

  sentChartOptions = {
    type: "serial",
    theme: "none",
    mouseWheelZoomEnabled: true,
    dataProvider: [],
    legend: {
      horizontalGap: 10,
      maxColumns: 2,
      position: "top",
      useGraphSettings: true,
      markerSize: 10,
    },
    valueAxes: [
      {
        stackType: "regular",
        axisAlpha: 0.3,
        gridAlpha: 0,
      },
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>(Sent)",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        title: "Sent",
        valueField: "sentCount",
        fillColors: ["#1E87F0", "#40BCF9"],
        fixedColumnWidth: 30,
      },
      {
        balloonText: "[[category]]: <b>[[value]]</b>(Received)",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        title: "Received ",
        valueField: "recivedCount",
        fillColors: ["#008000", "#008000"],
        fixedColumnWidth: 30,
      },
    ],
    categoryField: "year",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20,
      labelPosition: "middle",
      labelRotation: 45,
    },
    export: {
      enabled: true,
    },
  };

  receivedChartOptions = {
    type: "serial",
    theme: "none",
    dataProvider: [],
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        minimum: 0,
      },
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "value",
        fillColors: ["#1E87F0", "#40BCF9"],
        fixedColumnWidth: 30,
      },
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    categoryField: "year",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20,
      labelPosition: "middle",
      labelRotation: 45,
    },
    export: {
      enabled: true,
    },
  };

  templateChartOptions = {
    type: "serial",
    theme: "none",
    mouseWheelZoomEnabled: true,
    dataProvider: [],
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        minimum: 0,
      },
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "value",
        fillColors: ["#1E87F0", "#40BCF9"],
        fixedColumnWidth: 30,
      },
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    categoryField: "year",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20,
      labelPosition: "middle",
      labelRotation: 45,
    },
    export: {
      enabled: true,
    },
  };

  templateDeliveredChartOptions = {
    type: "serial",
    theme: "none",
    dataProvider: [],
    legend: {
      horizontalGap: 10,
      maxColumns: 2,
      position: "top",
      useGraphSettings: true,
      markerSize: 10,
    },
    valueAxes: [
      {
        stackType: "regular",
        axisAlpha: 0.3,
        gridAlpha: 0,
      },
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>(Sent)",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        title: "Sent",
        valueField: "sentCount",
        fillColors: ["#1E87F0", "#40BCF9"],
        fixedColumnWidth: 30,
      },
      {
        balloonText: "[[category]]: <b>[[value]]</b>(Delivered)",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        title: "Delivered",
        valueField: "recivedCount",
        fillColors: ["#008000", "#008000"],
        fixedColumnWidth: 30,
      },
    ],
    // chartCursor: {
    //   categoryBalloonEnabled: false,
    //   cursorAlpha: 0,
    //   zoomable: false,
    // },
    categoryField: "year",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20,
      labelPosition: "middle",
      labelRotation: 45,
    },
    export: {
      enabled: true,
    },
  };
  downLoadDate: any = moment().subtract(1, "days");
  downLoadMonth: any = moment();
  applicationList: any;
  userData: any;
  selectedApp: any;
  bsValue = new Date();
  bsValue1 = new Date(moment(Date.now()).subtract(1, 'days').toJSON())
  bsValueMonth = new Date();
  bsRangeValue: Date[];
  last30DaysToDate: any = moment().format("YYYY-MM-DD");
  last30DaysFromDate: any = moment().subtract(30, "days").format("YYYY-MM-DD");
  toDate: any = moment();
  fromDate: any = moment().subtract(30, "days");
  connectors: any;
  todaysDate: any = moment();
  chooseDate: boolean = false;
  noRecords: boolean = true;
  noWebaRecords: boolean = false;
  WebaLoad: boolean = true;
  noRecordsReceived: boolean = true;
  noTemplateRecordsReceived: boolean = true;
  noTemplateDeliveredRecordsReceived: boolean = true;
  selectedConnector: any;
  apiDetails: any;
  receivedApiDetails: any;
  selectedPeriod: string;
  selectedDateRange: any;
  selectedRangeApiData: any;
  selectedRangeReceivedApiData: any;
  loadershow: boolean = false;
  totalCountByConnectors: any;
  totalCount: any;
  deviceConnectorsCount: any;
  messagingConnectorsCount: any;
  hsmCountByConnectors: any;
  todaysCount: any;
  weeklyCount: any;
  monthlyCount: any;
  yearlyCount: any;
  sentRenewedCount: any;
  receivedRenewedCount: any;
  connectorName: any;
  currentWeekStarts: any = moment();
  currentWeekEnds: any = moment();
  currentMonthStarts: any = moment();
  currentMonthEnds: any = moment();
  currentYearStarts: any = moment();
  currentYearEnds: any = moment();
  renewalDate: any;
  totalReceivedCountByConnectors: any;
  totalReceivedCount: any;
  deviceConnectorsReceivedCount: any;
  messagingConnectorsReceivedCount: any;
  todaysReceivedCount: any;
  weeklyReceivedCount: any;
  monthlyReceivedCount: any;
  yearlyReceivedCount: any;
  totalReceivedDateCount: any;
  totalDateCount: any;
  totalSentMessages: number;
  totalSentMessageLoader = true;
  totalDateCountLoader = true;
  todaysCountLoader = true;
  weeklyCountLoader = true;
  monthlyCountLoader = true;
  yearlyCountLoader = true;
  sentRenewCountLoader = true;
  receivedRenewCountLoader = true;
  totalCountByConnectorsLoader = true;
  hsmCountByConnectorsLoader = true;
  todaysReceivedCountLoader = true;
  weeklyReceivedCountLoader = true;
  monthlyReceivedCountLoader = true;
  yearlyReceivedCountLoader = true;
  totalReceivedCountByConnectorsLoader = true;
  totalReceivedDateCountLoader = true;
  totalReceivedMessages: number;
  totalReceivedMessageLoader: boolean;
  applicationId: string;
  showMessageSentStatus = true;
  showMessageReceivedStatus = false;
  dashboardChartSentDetails: any;
  dashboardChartTemplateDeliveredDetails: any;
  dashboardChartReceivedDetails: any;
  dashboardChartTemplateDetails: any;
  radioStatus: boolean = true;
  dateType: any = "day";
  wabaDetail:any;
  wabaDownload:boolean = false;
  templateDownload:boolean =false;
  addData:any;
  wabaSubTitles = [];
  constructor(
    private AmCharts: AmChartsService,
    private applicationService: ApplicationService,
    private dashboardService: DashboardService,
    public translate: TranslateService,
    public datepipe: DatePipe,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.downLoadDate = this.downLoadDate._d;
    this.downLoadMonth = this.downLoadMonth._d;
    //console.log('dateFormat',this.downLoadDate);
    this.loadershow = true;
    this.selectedPeriod = "day";
    this.bsRangeValue = [
      new Date(Date.parse(this.fromDate._d)),
      new Date(Date.parse(this.toDate._d)),
    ];
    this.userData = JSON.parse(localStorage.getItem("user"));
    this.selectedDateRange = "last30";
    this.fromDate = moment(this.fromDate).format("YYYY-MM-DD");
    this.toDate = moment(this.toDate).format("YYYY-MM-DD");
    this.todaysDate = moment(this.todaysDate).format("YYYY-MM-DD");
    this.getApplicationList();
  }

  /** APPLICATION LIST CALL**/
  getApplicationList() {
    let args = { developerId: this.userData.id };

    this.applicationService.getApplicationList(args).subscribe(async (data) => {
      this.loadershow = false;
      if (data && data.status == true) {
        this.applicationList = data.info.filter(function(el){
          return !el.isDisabled;
        });
        this.selectedApp = data.info.find(function(el){
          return !el.isDisabled;
        });
        this.renewalDate = moment(data.info[0].lastRenewedAt).format(
          "YYYY-MM-DD"
        );
        let connectorData = this.selectedApp
          ? await this.getConnectorsList()
          : undefined;
        if (connectorData && connectorData.status == true) {
          this.connectors = connectorData["info"];
          this.selectedConnector = this.connectors[0];
          this.selectChangeChannel(this.selectedConnector);
          this.getDashboardChartDetails();
          this.sentDataCountSection();
          this.receivedDataCountSection();
          this.getDateWiseTotalMessageCount();
          this.getDatewiseTotalReceivedCount();
          this.wabaConversationAnalytics()
        } else {
          this.connectors = [];
          this.selectedConnector = "";
          this.totalDateCountLoader = false;
          this.totalDateCount = 0;
          this.totalSentMessageLoader = false;
          this.totalSentMessages = 0;
          this.todaysCountLoader = false;
          this.todaysCount = 0;
          this.weeklyCountLoader = false;
          this.weeklyCount = 0;
          this.monthlyCountLoader = false;
          this.monthlyCount = 0;
          this.yearlyCountLoader = false;
          this.yearlyCount = 0;
          this.sentRenewCountLoader = false;
          this.sentRenewedCount = 0;
          this.receivedRenewCountLoader = false;
          this.receivedRenewedCount = 0;
          this.totalCountByConnectorsLoader = false;
          this.totalCountByConnectors = 0;
          this.hsmCountByConnectorsLoader = false;
          this.hsmCountByConnectors = 0;
          this.totalReceivedDateCountLoader = false;
          this.totalReceivedDateCount = 0;
          this.totalReceivedMessageLoader = false;
          this.totalReceivedMessages = 0;
          this.todaysReceivedCountLoader = false;
          this.todaysReceivedCount = 0;
          this.weeklyReceivedCountLoader = false;
          this.weeklyReceivedCount = 0;
          this.monthlyReceivedCountLoader = false;
          this.monthlyReceivedCount = 0;
          this.yearlyReceivedCountLoader = false;
          this.yearlyReceivedCount = 0;
          this.totalReceivedCountByConnectorsLoader = false;
          this.totalReceivedCountByConnectors = 0;
        }
      }
    });
  }

  /** CONNECTOR LIST CALL **/
  async getConnectorsList() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
    };

    return await this.dashboardService.getConnectorsList(args).toPromise();
  }

  sentDataCountSection() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
    };

    this.getDateWiseTotalMessageCount();
    this.totalSentMsgCount(args);
    this.sentTodaysCount();
    this.sentWeeklyCount();
    this.sentMonthlyCount();
    this.sentYearlyCount();
    this.getSentCountByConnectors();
    this.getSentCountByRenewDate();
    if (this.selectedConnector.hasHsm) {
      this.sentHsmCount();
    }
  }

  receivedDataCountSection() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
    };

    this.getDatewiseTotalReceivedCount();
    this.totalReceivedMsgCount(args);
    this.receivedTodaysCount();
    this.receivedWeeklyCount();
    this.receivedMonthlyCount();
    this.receivedYearlyCount();
    this.getReceivedCountByConnectors();
    this.getReceivedCountByRenewDate();
  }

  sentTodaysCount() {
    this.todaysCountLoader = true;
    this.todaysDate = moment(this.todaysDate).format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.todaysDate,
      toDate: this.todaysDate,
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.todaysCount = data.info.totalCount;
          this.todaysCountLoader = false;
        } else {
          this.todaysCountLoader = false;
        }
      },
      (err) => {
        this.todaysCountLoader = false;
      }
    );
  }

  sentWeeklyCount() {
    this.weeklyCountLoader = true;
    this.currentWeekStarts = moment().startOf("week").format("YYYY-MM-DD");
    this.currentWeekEnds = moment().endOf("week").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentWeekStarts,
      toDate: this.currentWeekEnds,
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.weeklyCount = data.info.totalCount;
          this.weeklyCountLoader = false;
        } else {
          this.weeklyCountLoader = false;
        }
      },
      (err) => {
        this.weeklyCountLoader = false;
      }
    );
  }

  sentMonthlyCount() {
    this.monthlyCountLoader = true;
    this.currentMonthStarts = moment().startOf("month").format("YYYY-MM-DD");
    this.currentMonthEnds = moment().endOf("month").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentMonthStarts,
      toDate: this.currentMonthEnds,
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.monthlyCount = data.info.totalCount;
          this.monthlyCountLoader = false;
        } else {
          this.monthlyCountLoader = false;
        }
      },
      (err) => {
        this.monthlyCountLoader = false;
      }
    );
  }

  sentYearlyCount() {
    this.yearlyCountLoader = true;
    this.currentYearStarts = moment().startOf("year").format("YYYY-MM-DD");
    this.currentYearEnds = moment().endOf("week").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentYearStarts,
      toDate: this.currentYearEnds,
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.yearlyCount = data.info.totalCount;
          this.yearlyCountLoader = false;
        } else {
          this.yearlyCountLoader = false;
        }
      },
      (err) => {
        this.yearlyCountLoader = false;
      }
    );
  }

  getSentCountByConnectors() {
    this.totalCountByConnectorsLoader = true;
    this.loadershow = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      connectorId: this.selectedConnector.id,
    };
    this.applicationService.getNumberOfMessagesSentCount(args).subscribe(
      async (data) => {
        this.loadershow = false;
        if (data && data.status == true) {
          this.totalCountByConnectors = data.info;
          this.totalCountByConnectorsLoader = false;
        } else {
          this.totalCountByConnectorsLoader = false;
        }
      },
      (err) => {
        this.totalCountByConnectorsLoader = false;
      }
    );
  }

  getReceivedCountByRenewDate() {
    this.receivedRenewCountLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.renewalDate,
      toDate: this.todaysDate,
    };
    this.applicationService.renewedReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.receivedRenewedCount = data.info.totalCount;
          this.receivedRenewCountLoader = false;
        } else {
          this.receivedRenewCountLoader = false;
        }
      },
      (err) => {
        this.receivedRenewCountLoader = false;
      }
    );
  }

  sentHsmCount() {
    this.hsmCountByConnectorsLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      connectorId: this.selectedConnector.id,
    };

    this.applicationService.getHsmMessagesCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.hsmCountByConnectors = data.total;
          this.hsmCountByConnectorsLoader = false;
        } else {
          this.hsmCountByConnectorsLoader = false;
        }
      },
      (err) => {
        this.hsmCountByConnectorsLoader = false;
      }
    );
  }

  receivedTodaysCount() {
    this.todaysReceivedCountLoader = true;
    this.todaysDate = moment(this.todaysDate).format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.todaysDate,
      toDate: this.todaysDate,
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.todaysReceivedCount = data.info.totalCount;
          this.todaysReceivedCountLoader = false;
        } else {
          this.todaysReceivedCountLoader = false;
        }
      },
      (err) => {
        this.todaysReceivedCountLoader = false;
      }
    );
  }

  receivedWeeklyCount() {
    this.weeklyReceivedCountLoader = true;
    this.currentWeekStarts = moment().startOf("week").format("YYYY-MM-DD");
    this.currentWeekEnds = moment().endOf("week").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentWeekStarts,
      toDate: this.currentWeekEnds,
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.weeklyReceivedCount = data.info.totalCount;
          this.weeklyReceivedCountLoader = false;
        } else {
          this.weeklyReceivedCountLoader = false;
        }
      },
      (err) => {
        this.weeklyReceivedCountLoader = false;
      }
    );
  }

  receivedMonthlyCount() {
    this.monthlyReceivedCountLoader = true;
    this.currentMonthStarts = moment().startOf("month").format("YYYY-MM-DD");
    this.currentMonthEnds = moment().endOf("month").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentMonthStarts,
      toDate: this.currentMonthEnds,
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.monthlyReceivedCount = data.info.totalCount;
          this.monthlyReceivedCountLoader = false;
        } else {
          this.monthlyReceivedCountLoader = false;
        }
      },
      (err) => {
        this.monthlyReceivedCountLoader = false;
      }
    );
  }

  receivedYearlyCount() {
    this.yearlyReceivedCountLoader = true;
    this.currentYearStarts = moment().startOf("year").format("YYYY-MM-DD");
    this.currentYearEnds = moment().endOf("week").format("YYYY-MM-DD");
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.currentYearStarts,
      toDate: this.currentYearEnds,
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.yearlyReceivedCount = data.info.totalCount;
          this.yearlyReceivedCountLoader = false;
        } else {
          this.yearlyReceivedCountLoader = false;
        }
      },
      (err) => {
        this.yearlyReceivedCountLoader = false;
      }
    );
  }

  getSentCountByRenewDate() {
    this.sentRenewCountLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.renewalDate,
      toDate: this.todaysDate,
    };

    this.applicationService.renewedSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.sentRenewedCount = data.info.totalCount;
          this.sentRenewCountLoader = false;
        } else {
          this.sentRenewCountLoader = false;
        }
      },
      (err) => {
        this.sentRenewCountLoader = false;
      }
    );
  }

  getReceivedCountByConnectors() {
    this.totalReceivedCountByConnectorsLoader = true;
    this.loadershow = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      connectorId: this.selectedConnector.id,
    };
    this.dashboardService.getReceivedCountByConnectors(args).subscribe(
      async (data) => {
        this.loadershow = false;
        if (data && data.status == true) {
          this.totalReceivedCountByConnectors = data.info;
          this.totalReceivedCountByConnectorsLoader = false;
        } else {
          this.totalReceivedCountByConnectorsLoader = false;
        }
      },
      (err) => {
        this.totalReceivedCountByConnectorsLoader = false;
      }
    );
  }

  /** CHART DATA LIST CALL**/
  getDashboardChartDetails() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      connectorId: this.selectedConnector.id,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    
    forkJoin([
      this.dashboardService.getDashboardChartSentDetails(args),
      this.dashboardService.getDashboardChartReceivedDetails(args),
    ]).subscribe((data) => {
      console.log("data send/recv", data)
      if (data && data[0].status == true && data[0].info[this.selectedConnector.name]) {
        this.noRecords = false;
        this.dashboardChartSentDetails = this.processChartDataDetails(
          data[0].info[this.selectedConnector.name]
        );
        this.dashboardChartReceivedDetails = this.processChartDataDetails(
          data[1].info[this.selectedConnector.name]
        );
        console.log("send details" , this.dashboardChartSentDetails)
        console.log("received details" , this.dashboardChartReceivedDetails)
        // this.dashboardChartSentDetails=this.processChartDataDetails(this.dashboardChartSentDetails);
        this.makeCharts();
      } else {
        // console.log('else');
        this.noRecords = true;
        if (this.chart) {
          this.chart.clear();
        }
      }
    });
    // this.dashboardService.getDashboardChartSentDetails(args).subscribe(data => {
    // 	this.loadershow = false;
    // 	if(data && data.status == true) {
    // 		this.dashboardChartSentDetails = data.info[this.selectedConnector.name];
    // 		this.makeCharts();
    // 	} else {
    // 		this.noRecords = true;
    // 		if(this.chart) {
    // 			this.chart.clear();
    // 		}
    // 	}
    // });

    // this.dashboardService.getDashboardChartReceivedDetails(args).subscribe(data => {
    // 	this.loadershow = false;
    // 	if(data && data.status == true) {
    // 		this.dashboardChartReceivedDetails = data.info[this.selectedConnector.name];
    // 		this.makeCharts();
    // 	} else {
    // 		this.noRecordsReceived = true;
    // 		if(this.chartReceived) {
    // 			this.chartReceived.clear();
    // 		}
    // 	}
    // });

    this.dashboardService
      .getDashboardChartTemplateDetails(args)
      .subscribe((data) => {
        this.loadershow = false;
        if (data && data.status == true) {
          this.dashboardChartTemplateDetails =
            data.info[this.selectedConnector.name];
          this.makeTemplateCharts();

          this.dashboardService
          .getTemplateCount(argstemplatedelivered)
          .subscribe((data) => {
            this.loadershow = false;
            if (data && data.status == true) {
              this.dashboardChartTemplateDeliveredDetails = data.info;

              this.makeTemplateDeliveredCharts();
            } else {
              this.noTemplateDeliveredRecordsReceived = true;
              if (this.templateDeliveredChart) {
                this.templateDeliveredChart.clear();
              }
            }
          });


        } else {
          this.noTemplateRecordsReceived = true;
          if (this.templateChart) {
            this.templateChart.clear();
          }
        }
      });

    let argstemplatedelivered = {
      applicationId: this.selectedApp.id,
      scheme: this.selectedConnector.scheme,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
  }

  /** SELECTED APPLICATION CHANGE **/
  async selectChangeApplication() {
    let connectorData = await this.getConnectorsList();
    this.renewalDate = moment(this.selectedApp.lastRenewedAt).format(
      "YYYY-MM-DD"
    );
    if (connectorData && connectorData.status == true) {
      this.connectors = connectorData["info"];
      this.selectedConnector = this.connectors[0];
      this.selectChangeChannel(this.selectedConnector);
    } else {
      this.connectors = [];
      this.selectedConnector = "";
    }

    this.getDashboardChartDetails();
    this.sentDataCountSection();
    this.receivedDataCountSection();
    this.getDateWiseTotalMessageCount();
    this.getDatewiseTotalReceivedCount();
    this.wabaConversationAnalytics()
  }

  /** SELECTED CHANNEL CHANGE **/
  selectChangeChannel(connector) {
    this.selectedConnector = connector;
    this.appName = this.selectedConnector.name;
    this.getSentCountByConnectors();
    this.getReceivedCountByConnectors();
    if (this.selectedConnector.hasHsm) {
      this.sentHsmCount();
    }
    this.getDashboardChartDetails();
      this.wabaConversationAnalytics()
  }

  /** SELECTED PERIOD CHANGE **/
  selectChangePeriod(period) {
    this.selectedPeriod = period;
    this.getDashboardChartDetails();
    this.wabaConversationAnalytics()
  }

  /** APPLICATION TOTAL SENT MESSAGE COUNT(DATEWISE) **/
  getDateWiseTotalMessageCount() {
    this.totalDateCountLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalDateCount = data.info.totalCount;
          this.totalDateCountLoader = false;
        } else {
          this.totalDateCountLoader = false;
        }
      },
      (err) => {
        this.totalDateCountLoader = false;
      }
    );
  }

  /** APPLICATION TOTAL RECEIVED MESSAGE COUNT(DATEWISE) **/
  getDatewiseTotalReceivedCount() {
    this.totalReceivedDateCountLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.selectedApp.id,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalReceivedDateCount = data.info.totalCount;
          this.totalReceivedDateCountLoader = false;
        } else {
          this.totalReceivedDateCountLoader = false;
        }
      },
      (err) => {
        this.totalReceivedDateCountLoader = false;
      }
    );
  }

  /** PROCESS DATA FOR CHARTS BY DAY WEEK MONTH **/
  processChartDataDetails(chartDetails) {
    let dataProvider = [];
    if (chartDetails) {
      if (this.selectedPeriod === "day") {
        Object.keys(chartDetails).forEach((key) => {
          let obj = {};
          obj["year"] = key;
          obj["value"] = chartDetails[key];
          dataProvider.push(obj);
        });
      }

      let res = [];
      if (this.selectedPeriod === "week") {
        Object.keys(chartDetails).forEach((key) => {
          const currentWeek = moment(key, "YYYY-MM-DD").isoWeek();
          const currentYear = moment(key, "YYYY-MM-DD").year();

          let obj2 = {};
          obj2["year"] = "Week " + currentWeek + "-" + currentYear;
          obj2["value"] = chartDetails[key];
          res.push(obj2);
        });
        let weekArray = _.chain(res)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();

        _.filter(weekArray, (items) => {
          dataProvider.push(items);
        });
      }

      let res2 = [];
      if (this.selectedPeriod === "month") {
        Object.keys(chartDetails).forEach((key) => {
          const currentMonthYear = moment(key).format("YYYY-MMM");

          let obj2 = {};
          obj2["year"] = currentMonthYear;
          obj2["value"] = chartDetails[key];
          res2.push(obj2);
        });
        let monthArray = _.chain(res2)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();
        _.filter(monthArray, (items) => {
          dataProvider.push(items);
        });
      }
    }
    return dataProvider;
  }

  processChartTemplateDeliveredDataDetails(chartDetails) {
    let dataProvider = [];
    if (chartDetails) {
      if (this.selectedPeriod === "day") {
        Object.keys(chartDetails).forEach((key) => {
          let obj = {};
          var check = moment(chartDetails[key].toDate, "YYYY/MM/DD");
          this.yeartoActive = check.format("YYYY");
          obj["year"] = chartDetails[key].toDate;
          obj["value"] = chartDetails[key].delivered;
          if (chartDetails[key].delivered != 0) {
            dataProvider.push(obj);
          }
        });
      }

      let res = [];
      if (this.selectedPeriod === "week") {
        Object.keys(chartDetails).forEach((key) => {
          const currentWeek = moment(
            chartDetails[key].toDate,
            "YYYY-MM-DD"
          ).isoWeek();
          const currentYear = moment(
            chartDetails[key].toDate,
            "YYYY-MM-DD"
          ).year();

          let obj2 = {};
          obj2["year"] = "Week " + currentWeek + "-" + currentYear;
          obj2["value"] = chartDetails[key].delivered;
          if (chartDetails[key].delivered != 0) {
            res.push(obj2);
          }
        });

        let weekArray = _.chain(res)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();

        _.filter(weekArray, (items) => {
          dataProvider.push(items);
        });
      }

      let res2 = [];
      if (this.selectedPeriod === "month") {
        Object.keys(chartDetails).forEach((key) => {
          const currentMonthYear = moment(chartDetails[key].toDate).format(
            "YYYY-MMM"
          );

          let obj2 = {};
          obj2["year"] = currentMonthYear;
          obj2["value"] = chartDetails[key].delivered;
          if (chartDetails[key].delivered != 0) {
            res2.push(obj2);
          }
        });
        let monthArray = _.chain(res2)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();
        _.filter(monthArray, (items) => {
          dataProvider.push(items);
        });
      }
    }
    return dataProvider;
  }

  processChartTemplateSentDataDetails(chartDetails) {
    let dataProvider = [];
    if (chartDetails) {
      if (this.selectedPeriod === "day") {
        Object.keys(chartDetails).forEach((key) => {
          let obj = {};
          var check = moment(chartDetails[key].toDate, "YYYY/MM/DD");
          this.yeartoActive = check.format("YYYY");
          obj["year"] = chartDetails[key].toDate;
          obj["value"] = chartDetails[key].sent;
          if (chartDetails[key].sent != 0) {
            dataProvider.push(obj);
          }
        });
      }

      let res = [];
      if (this.selectedPeriod === "week") {
        Object.keys(chartDetails).forEach((key) => {
          const currentWeek = moment(
            chartDetails[key].toDate,
            "YYYY-MM-DD"
          ).isoWeek();
          const currentYear = moment(
            chartDetails[key].toDate,
            "YYYY-MM-DD"
          ).year();

          let obj2 = {};
          obj2["year"] = "Week " + currentWeek + "-" + currentYear;
          obj2["value"] = chartDetails[key].sent;
          if (chartDetails[key].sent != 0) {
            res.push(obj2);
          }
        });

        let weekArray = _.chain(res)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();

        _.filter(weekArray, (items) => {
          dataProvider.push(items);
        });
      }

      let res2 = [];
      if (this.selectedPeriod === "month") {
        Object.keys(chartDetails).forEach((key) => {
          const currentMonthYear = moment(chartDetails[key].toDate).format(
            "YYYY-MMM"
          );

          let obj2 = {};
          obj2["year"] = currentMonthYear;
          obj2["value"] = chartDetails[key].sent;
          if (chartDetails[key].sent != 0) {
            res2.push(obj2);
          }
        });
        let monthArray = _.chain(res2)
          .groupBy("year")
          .map((value, key) => {
            let values = _.pluck(value, "value");
            let count = values.reduce((a, b) => {
              return a + b;
            });
            return {
              year: key,
              value: count,
            };
          })
          .value();
        _.filter(monthArray, (items) => {
          dataProvider.push(items);
        });
      }
    }
    return dataProvider;
  }

  /** SENT MESSAGES CHART CREATION **/
  makeCharts() {
    let sentChartData = [];
    if (
      this.dashboardChartSentDetails.length != 0 ||
      this.dashboardChartReceivedDetails.length != 0
    ) {
      this.noRecords = true;
      let chartData = [];
      this.dashboardChartSentDetails.forEach((element) => {
        let chartItem = {};
        chartItem["year"] = element.year;
        chartItem["sentCount"] = element.value;
        chartItem["recivedCount"] = 0;
        chartData.push(chartItem);
      });
      this.dashboardChartReceivedDetails.forEach((element) => {
        let chartItem = {};
        const index = chartData.indexOf(
          chartData.find((cItem) => {
            return cItem.year === element.year;
          })
        );
        if (index >= 0) {
          chartData[index].recivedCount = element.value;
        } else {
          chartItem["year"] = element.year;
          chartItem["recivedCount"] = element.value;
          chartItem["sentCount"] = 0;
          chartData.push(chartItem);
        }
      });
      chartData = chartData.sort(function (a, b) {
        return Number(new Date(a.year)) - Number(new Date(b.year));
      });
      // let ao;
      // ao = this.processChartDataDetails(this.dashboardChartSentDetails);
      let ChartDivAddData = this.getchartdivAddData(chartData)
      if (chartData) {
        //console.log(chartData,'chartdataaaa');
        this.sentChartOptions.dataProvider = chartData;
        this.noRecords = false;
        this.loadershow = false;
        this.chart = this.AmCharts.makeChart(
          "chartdiv",
          this.sentChartOptions,
          1
        );
        this.chart.graphs[0].title = "Sent ("+ ChartDivAddData[0].sentCount + ")";
        this.chart.graphs[1].title = "Received ("+ ChartDivAddData[0].recivedCount + ")";
      }
    }

    else {
      this.noRecords = true;
      if (this.chart) {
        this.chart.clear();
      }
    }
  }

  /** RECEIVED MESSAGES CHART CREATION **/
  //   makeReceivedCharts() {
  //     let receivedChartData = [];
  //     if (this.dashboardChartReceivedDetails) {
  //       this.noRecordsReceived = false;
  //       receivedChartData = this.processChartDataDetails(
  //         this.dashboardChartReceivedDetails
  //       );
  //       if (receivedChartData) {
  //         this.receivedChartOptions.dataProvider = receivedChartData;
  //         this.chartReceived = this.AmCharts.makeChart(
  //           "chartdivReceived",
  //           this.receivedChartOptions,
  //           1
  //         );
  //       } else {
  //         this.noRecordsReceived = true;
  //         if (this.chartReceived) {
  //           this.chartReceived.clear();
  //         }
  //       }
  //     } else {
  //       this.noRecordsReceived = true;
  //       if (this.chartReceived) {
  //         this.chartReceived.clear();
  //       }
  //     }
  //   }

  /** TEMPLATE MESSAGES CHART CREATION **/
  makeTemplateCharts() {
    let templateChartData = [];
    if (this.dashboardChartTemplateDetails) {
      this.noTemplateRecordsReceived = false;
      templateChartData = this.processChartDataDetails(
        this.dashboardChartTemplateDetails
      );
      if (templateChartData) {
        this.templateChartOptions.dataProvider = templateChartData;
        // this.templateChart = this.AmCharts.makeChart("chartdivTemplate", this.templateChartOptions, 1);
      } else {
        this.noTemplateRecordsReceived = true;
        if (this.templateChart) {
          this.templateChart.clear();
        }
      }
    } else {
      this.noTemplateRecordsReceived = true;
      if (this.templateChart) {
        this.templateChart.clear();
      }
    }
  }

  /** TEMPLATE MESSAGES CHART CREATION **/
  makeTemplateDeliveredCharts() {
    let templateChartData = [];
    let templateChartDataSent = [];
    let chartsData = [];
    if (
      this.dashboardChartTemplateDeliveredDetails &&
      this.dashboardChartTemplateDetails
    ) {
      this.noTemplateDeliveredRecordsReceived = false;
      templateChartDataSent = this.processChartTemplateSentDataDetails(
        this.dashboardChartTemplateDeliveredDetails
      );
      templateChartData = this.processChartTemplateDeliveredDataDetails(
        this.dashboardChartTemplateDeliveredDetails
      );
      templateChartData.forEach((element) => {
        let chartItem = {};
        chartItem["year"] = element.year;
        chartItem["recivedCount"] = element.value;
        chartItem["sentCount"] = 0;
        chartsData.push(chartItem);
      });
      templateChartDataSent.forEach((element) => {
        let chartItem = {};
        const index = chartsData.indexOf(
          chartsData.find((cItem) => {
            return cItem.year === element.year;
          })
        );

        if (index >= 0) {
          chartsData[index].sentCount = element.value;
        } else {
          chartItem["year"] = element.year;
          chartItem["sentCount"] = element.value;
          chartItem["recivedCount"] = 0;
          chartsData.push(chartItem);
        }
      });
      chartsData = chartsData.sort(function (a, b) {
        return Number(new Date(a.year)) - Number(new Date(b.year));
      });
      let getTemplateAddData = this.getTemplateChartdivAddData(chartsData)
      if (chartsData) {
        this.templateDeliveredChartOptions.dataProvider = chartsData;
        this.templateDeliveredChart = this.AmCharts.makeChart(
          "chartdivTemplate",
          this.templateDeliveredChartOptions,
          1
        );
        this.templateDeliveredChart.graphs[0].title = "Sent ("+ getTemplateAddData[0].sentCount + ")";
        this.templateDeliveredChart.graphs[1].title = "Delivered ("+ getTemplateAddData[0].recivedCount + ")";

      } else {
        this.noTemplateDeliveredRecordsReceived = true;
        if (this.templateDeliveredChart) {
          this.templateDeliveredChart.clear();
        }
      }
    } else {
      this.noTemplateDeliveredRecordsReceived = true;
      if (this.templateDeliveredChart) {
        this.templateDeliveredChart.clear();
      }
    }
  }

  /** SELECT DATES ON CALENDAR **/
  selectDates(events) {
    if (events) {
      this.fromDate = moment(events[0]).format("YYYY-MM-DD");
      this.toDate = moment(events[1]).format("YYYY-MM-DD");
      this.radioStatus =
        moment(events[1]).diff(moment(events[0]), "days") > 30 ? false : true;
      if (this.radioStatus == false) {
        this.selectedPeriod = "week";
      } else {
        this.selectedPeriod = "day";
      }
      this.getDashboardChartDetails();
      this.wabaConversationAnalytics()
    }
  }

  /** SELECT DATE RANGE **/
  switchDateRange() {
    if (this.selectedDateRange === "last30") {
      this.chooseDate = false;
      this.radioStatus = true;
      this.selectedPeriod = "day";
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.getDashboardChartDetails();
      this.wabaConversationAnalytics()
    }
    if (this.selectedDateRange === "choosedate") {
      this.chooseDate = true;
      this.selectedPeriod = "day";
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.radioStatus =
        moment(this.fromDate).diff(moment(this.toDate), "days") > 30
          ? false
          : true;
      if (this.radioStatus == false) {
        this.selectedPeriod = "week";
      } else {
        this.selectedPeriod = "day";
      }
      this.getDashboardChartDetails();
      this.wabaConversationAnalytics()
    }
    // this.wabaChartGraphsVar = [];
    // this.wabaSubTitles = [];
  }
  /** TOTAL MESSAGES SENT **/
  totalSentMsgCount(args) {
    this.totalSentMessageLoader = true;
    this.applicationService.totalSentMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalSentMessages = res.info.totalCount;
          this.totalSentMessageLoader = false;
        } else {
          this.totalSentMessageLoader = false;
        }
      },
      (err) => {
        this.totalSentMessageLoader = false;
      }
    );
  }

  /** TAB SWITCH MESSAGE SENT AND RECEIVED**/
  switchTab() {
    if (this.showMessageReceivedStatus === true) {
      this.showMessageReceivedStatus = false;
      this.showMessageSentStatus = true;
    } else {
      this.showMessageReceivedStatus = true;
      this.showMessageSentStatus = false;
    }
  }

  /** TOTAL MESSAGES RECEIVED **/
  totalReceivedMsgCount(args) {
    this.totalReceivedMessageLoader = true;
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalReceivedMessages = res.info.totalCount;
          this.totalReceivedMessageLoader = false;
        } else {
          this.totalReceivedMessageLoader = false;
        }
      },
      (err) => {
        this.totalReceivedMessageLoader = false;
      }
    );
  }
  // Download

  downloadTemplateCount() {
    let latest_date = this.datepipe.transform(this.downLoadDate, "yyyy-MM-dd");
    //console.log('date',latest_date,'  dateType',this.dateType);
    var args;
    if (this.dateType == "month") {
      var fDay = new Date(
        this.downLoadMonth.getFullYear(),
        this.downLoadMonth.getMonth(),
        1
      );
      var lDay = new Date(
        this.downLoadMonth.getFullYear(),
        this.downLoadMonth.getMonth() + 1,
        0
      );
      let firstDay = this.datepipe.transform(fDay, "yyyy-MM-dd");
      let lastDay = this.datepipe.transform(lDay, "yyyy-MM-dd");
      //console.log('first day',firstDay,' Last Day',lastDay);
      args = {
        scheme: this.selectedConnector.scheme,
        applicationId: this.selectedApp.id,
        fromDate: firstDay,
        toDate: lastDay,
      };
    } else {
      args = {
        scheme: this.selectedConnector.scheme,
        applicationId: this.selectedApp.id,
        fromDate: latest_date,
        toDate: latest_date,
      };
    }
    const fileName = "Template_usage_report" + latest_date + ".xlsx";
    this.dashboardService.getdDownloadTemplateCount(args).subscribe((data) => {
      if (data.info.length > 0 && data.status == true) {
        data.info.forEach((element) => {
          element.date = this.datepipe.transform(element.date, "MM-dd-yyyy");
        });

        const opts = {
          headers: true,
          column: { style: { Font: { Bold: "1" } } },
          rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
          cells: {
            1: {
              1: {
                style: { Font: { Color: "#00FFFF" } },
              },
            },
          },
        };
        alasql(
          'SELECT date as [Date (mm-dd-yyyy)], channel as [Channel],channelId as [Channel ID],customerName as [Customer Name], customerId as [Customer ID], region as [Country],delivered as [Delivered Template Messages Count],messageCostActualValue as [Cost(USD)] INTO XLSX("' +
            fileName +
            '",?) FROM ?',
          [opts, data.info]
        );
        this.closeModalDialog("downloadModalCenter");
      } else {
        // this.toastr.error('No data found');
        const opts = {
          headers: true,
          column: { style: { Font: { Bold: "1" } } },
          rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
          cells: {
            1: {
              1: {
                style: { Font: { Color: "#00FFFF" } },
              },
            },
          },
        };
        alasql(
          'SELECT date as [Date (mm-dd-yyyy)], channel as [Channel], customerName as [Customer Name], customerId as [Customer ID], region as [Country],channelId as [Channel ID],delivered as [Delivered  Template Messages Count],messageCostActualValue as [Cost (USD)] INTO XLSX("' +
            fileName +
            '",?) FROM ?',
          [opts, data.info]
        );
        this.templateDownload= false;
        this.wabaDownload=false;
        this.closeModalDialog("downloadModalCenter");
      }
    });
  }

  closeModalDialog(id) {
    $("#" + id).modal("hide");
    }
  wabaConversationAnalytics(){
        let args = {
          developerId: this.userData.id,
          applicationId: this.selectedApp.id,
          connectorId: this.selectedConnector.id,
          scheme: this.selectedConnector.scheme,
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
        this.WebaLoad = false;
        this.dashboardService.getWabaConversationAnalytics(args).subscribe(data=>{
          if(data.status){
            console.log("waba data", data)
            this.wabaDetail = this.wabaDetails(data.info);
            this.makeWabaCharts(this.wabaDetail)
            this.noWebaRecords = false;
          } else {
            this.noWebaRecords = true;
            this.WebaLoad = true;
            this.wabaDetail=[]
            if (this.chart) {
              this.chart.clear();
            }
          }
        })
  }
  iterateWabadata(value) {
    let object = {};
    value.map(val => {
      console.log("val", val)
      for (let data in val) {
        console.log("data iterate", data)
        if (data !== 'date') {
          object[data] = _.pluck(value, data);
        }
      }
    })
    return object
  }
  wabaDetails(data){
    if(data){
        data.sort((a,b) => (a.end > b.end) ? 1 : ((b.end > a.end) ? -1 : 0))
        let dataProvider=[];
        if (this.selectedPeriod === "day") {
          let dataProvide = this.fetchData(data)
          let arr= JSON.parse(JSON.stringify(dataProvide))
          let graphValue={};
            _.chain(arr)
              .groupBy("date")
              .map((value, key) => {
                let object = this.iterateWabadata(value);
                 for (const key in object) {
                  let count = object[key].reduce( (s, v)=> { return s + (v || 0); }, 0);
                graphValue[key]= count
                 }
                 graphValue["date"]= key
                 let arr= JSON.parse(JSON.stringify(graphValue));
                 graphValue={};
                  dataProvider.push(arr);
                })
      }
    if (this.selectedPeriod === "week") {
      let dataProvide = this.fetchData(data)
    let arr= JSON.parse(JSON.stringify(dataProvide))
    arr.forEach(res=>{
      const currentWeek = moment(res.date, "YYYY-MM-DD").isoWeek();
      const currentYear = moment(res.date, "YYYY-MM-DD").year();
      res.date = "Week " + currentWeek + "-" + currentYear;
    })
    let graphValue={};
      _.chain(arr)
        .groupBy("date")
        .map((value, key) => {
          let object = this.iterateWabadata(value);
           for (const key in object) {
          let count = object[key].reduce( (s, v)=> { return s + (v || 0); }, 0);
          graphValue[key]= count
           }
           graphValue["date"]= key
           let arr= JSON.parse(JSON.stringify(graphValue));
           graphValue={};
            dataProvider.push(arr);
        });
    }
      if (this.selectedPeriod === "month") {
        let dataProvide = this.fetchData(data)
    let arr= JSON.parse(JSON.stringify(dataProvide))
    arr.forEach(res=>{
      const currentMonthYear = moment(res.date).format("YYYY-MMM");
      res.date = currentMonthYear;
    })
    let graphValue={};
      _.chain(arr)
        .groupBy("date")
        .map((value, key) => {
          let object = this.iterateWabadata(value);
           for (const key in object) {
          let count = object[key].reduce( (s, v)=> { return s + (v || 0); }, 0);
          graphValue[key]= count
           }
           graphValue["date"]= key
           let arr= JSON.parse(JSON.stringify(graphValue));
           graphValue={};
            dataProvider.push(arr);
        });
      }
      return dataProvider
    }
  }
  fetchData(data){
    this.wabaSubTitles = [];
    let dataProvide = [];
    let title = {};
    let obj = {};
    data.map(elem=>{
      if(!obj["date"]){
        obj["date"] = elem.end;
      }
      else{
        if(obj["date"] !== elem.end){
          obj = {};
          obj["date"] = elem.end;
        }
      }
      let subVal = elem.conversation_direction !== 'UNKNOWN' ? elem.conversation_direction.split('_')[0] : '';
      var newStr = elem.conversation_type.replace(/_/g, "");
      let label;
      if(subVal)  {
        if(elem.conversation_category) {
          label = (subVal + '_' + newStr + '_' + elem.conversation_category).toLocaleLowerCase();
        } else {
          label = (subVal + '_' + newStr).toLocaleLowerCase();
        }
      } else {
        if(elem.conversation_category) {
          label = (newStr + '_' + elem.conversation_category).toLocaleLowerCase();
        } else {
          label = newStr.toLocaleLowerCase();
        }
      }
      obj[label] = obj[label] ? obj[label] + elem.conversation : elem.conversation;
        dataProvide.push(obj);
        if(!(label in title)) {
        title[label] = this.setTitleFunction(elem)
        }
      })
      this.wabaSubTitles.push(title)
      return [...new Map(dataProvide.map(item => [item["date"], item])).values()]
      }
      setTitleFunction(elem) {
        let str1 = this.setCapitalize(elem.conversation_type.replace(/_/g, ' '));
        let str2 = this.setCapitalize(elem.conversation_category)
        if(str1 == 'Free Entry Point'){
          str1 = 'Free Entry'
        }
        let string;
        if(str2) {
          string = str1 +" - "+str2
        } else {string = str1}
        let value;
        if(elem.conversation_direction !== 'UNKNOWN') {
          value = elem.conversation_direction + ' - ' + string
        } else {
         value = string;
        }
        return value;
      }
      setCapitalize(str1){
        return str1.toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
      makeWabaCharts(wabaData) {
        let graphsVar = [];
       if ( wabaData) {
         let chartData = [];
          wabaData.forEach((element) => {
          chartData.push(element);
        });
      chartData = chartData.sort(function (a, b) {
        return Number(new Date(a.date)) - Number(new Date(b.date));
      });
      this.addData = this.getAddData(chartData)
       this.wabaChartOptions.dataProvider = chartData;
        this.loadershow = false;
      console.log("this.wabaSubTitles", this.wabaSubTitles)
        for(let val in this.wabaSubTitles[0]) {
          let obj = {
            'balloonText':  `<div style ='background-color:#f0f1f2'><b> ${this.wabaSubTitles[0][val]} </b><br><span style='font-size:10px;'>[[category]]: <b>[[value]]</b></span></div>`,
            'fillAlphas': 0.8,
            'lineAlpha': 0.2,
            'labelText': "[[value]]",
            'type': "column",
            'title':  `${this.wabaSubTitles[0][val]} (${this.addData[0][val]})` ,
            'useLineColorForBulletBorder': true,
            'valueField': val,
            // 'fillColors': val.fillColors,
            'fixedColumnWidth': 30,
          }
          graphsVar.push(obj);
          this.wabaChartGraphsVar.push(obj)
        }
        this.wabaChartGraphsVar = JSON.parse(JSON.stringify(graphsVar))
        console.log("this.wabaChartGraphsVar", this.wabaChartGraphsVar)
        this.wabaChartOptions.graphs = this.wabaChartGraphsVar;
        this.chart = this.AmCharts.makeChart(
          "wabaChartdiv",
          this.wabaChartOptions,
         1
        );
        console.log("this.chart@@@@", this.chart)
        setTimeout(()=>{
          this.WebaLoad = true;
        }, 100)
    }
  }
  getAddData(data){
    let reducedData =[]
    let obj = {}
    data.map(elem =>{
    for(let val in elem) {
      if(val !== 'date') {
        obj[val] = obj[val] ? obj[val] + elem[val] : elem[val];
      }
    }
  })
    reducedData.push(obj)
    return reducedData
  }
  downloadWabaCount(){
    let latest_date = this.datepipe.transform(this.downLoadDate, "yyyy-MM-dd");
    var args;
    if (this.dateType == "month") {
      var fDay = new Date(
        this.downLoadMonth.getFullYear(),
        this.downLoadMonth.getMonth(),
        1
      );
      var lDay = new Date(
        this.downLoadMonth.getFullYear(),
        this.downLoadMonth.getMonth() + 1,
        0
      );
      let firstDay = this.datepipe.transform(fDay, "yyyy-MM-dd");
      let lastDay = this.datepipe.transform(lDay, "yyyy-MM-dd");
      args = {
        applicationId: this.selectedApp.id,
        scheme: this.selectedConnector.scheme,
        fromDate: firstDay,
        toDate: lastDay,
      };
    } else {
      args = {
        applicationId: this.selectedApp.id,
        scheme: this.selectedConnector.scheme,
        fromDate: latest_date,
        toDate: latest_date,
      };
    }
    const fileName = "Wabametrics_usage_report" + latest_date + ".xlsx";
    this.dashboardService.getDownloadWabaCount(args).subscribe((data) => {
      console.log("data.info dwnld",data.info)
      if (data.info.length > 0 && data.status == true) {
        data.info.forEach((element) => {
          element.date = this.datepipe.transform(element.date, "MM-dd-yyyy");
        });
        const opts = {
          headers: true,
          column: { style: { Font: { Bold: "1" } } },
          rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
          cells: {
            1: {
              1: {
                style: { Font: { Color: "#00FFFF" } },
              },
            },
          },
        };
        alasql(
          'SELECT date as [Date (mm-dd-yyyy)], applicationName as [Application Name] ,channel as [Channel],channelId as [Channel ID], customerId as [Customer Id], customerName as [Customer Name], conversation as [Conversation Count], conversationType as [Conversation Type], conversationCategory as [Conversation Category], cost as [Total Cost(USD)],country as [Country] INTO XLSX("' +
            fileName +
            '",?) FROM ?',
          [opts, data.info]
        );
        this.closeModalDialog("downloadModalCenter");
      } else {
        const opts = {
          headers: true,
          column: { style: { Font: { Bold: "1" } } },
          rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
          cells: {
            1: {
              1: {
                style: { Font: { Color: "#00FFFF" } },
              },
            },
          },
        };
        alasql(
          'SELECT date as [Date (mm-dd-yyyy)], applicationName as [Application Name] ,channel as [Channel],channelId as [Channel ID], customerId as [Customer Id], customerName as [Customer Name], conversation as [Conversation Count], conversationType as [Conversation Type], conversationCategory as [Conversation Category], cost as [Total Cost(USD)],country as [Country] INTO XLSX("' +
            fileName +
            '",?) FROM ?',
          [opts, data.info]
        );
        this.closeModalDialog("downloadModalCenter");
      }
    });
  }
  getchartdivAddData(data){
    let reducedData =[]
    let obj = {}
    data.map(elem =>{
      obj["sentCount"] = obj["sentCount"] ? obj["sentCount"] + elem.sentCount : elem.sentCount;
      obj["recivedCount"] = obj["recivedCount"] ? obj["recivedCount"] + elem.recivedCount : elem.recivedCount;
    })
    reducedData.push(obj)
    return reducedData
  }
  getTemplateChartdivAddData(data){
    let reducedData =[]
    let obj = {}
    data.map(elem =>{
      obj["sentCount"] = obj["sentCount"] ? obj["sentCount"] + elem.sentCount : elem.sentCount;
      obj["recivedCount"] = obj["recivedCount"] ? obj["recivedCount"] + elem.recivedCount : elem.recivedCount;
    })
    reducedData.push(obj)
    return reducedData
  }
}
